/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRequestFileSearchResult
 */
export interface APIRequestFileSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIRequestFileSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIRequestFileSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFileSearchResult
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFileSearchResult
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIRequestFileSearchResult
     */
    fileSize?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestFileSearchResult
     */
    storedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestFileSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIRequestFileSearchResult
     */
    requestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIRequestFileSearchResult
     */
    requestCertificate?: string;
}

/**
 * Check if a given object implements the APIRequestFileSearchResult interface.
 */
export function instanceOfAPIRequestFileSearchResult(value: object): value is APIRequestFileSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIRequestFileSearchResultFromJSON(json: any): APIRequestFileSearchResult {
    return APIRequestFileSearchResultFromJSONTyped(json, false);
}

export function APIRequestFileSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestFileSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'key': json['key'] == null ? undefined : json['key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'fileSize': json['file_size'] == null ? undefined : json['file_size'],
        'storedAt': json['stored_at'] == null ? undefined : (new Date(json['stored_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
    };
}

export function APIRequestFileSearchResultToJSON(value?: APIRequestFileSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'key': value['key'],
        'file_name': value['fileName'],
        'file_size': value['fileSize'],
        'stored_at': value['storedAt'] == null ? undefined : ((value['storedAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'request_id': value['requestId'],
        'request_certificate': value['requestCertificate'],
    };
}

